"use client";
import { generateSlug } from "@/helpers/generateSlug";
import { cn } from "@/lib/utils";
import { ArrowUpRight } from "lucide-react";
import Image, { StaticImageData } from "next/image";
import { Link } from "@/i18n/navigation";
import { usePathname } from "@/i18n/navigation";

interface PropsType {
  slug: string;
  name: string;
  imgSrc: StaticImageData | string;
  index?: number;
  className?: string;
  onClick?: () => void;
}
function RegionImageCard({ name, slug, imgSrc, className, onClick }: PropsType) {
  const pathName = usePathname();

  const content = (
    <div
      className={cn(
        "group relative h-[200px] w-full overflow-hidden rounded-[0.625rem] transition-transform hover:scale-105",
        className,
      )}
    >
      <div className="relative z-30 flex h-full flex-col justify-between text-background">
        <h3 className="ms-[1.2rem] mt-[0.5rem] text-start text-body-lg font-700 dark:text-primary-foreground">
          {name}
        </h3>
        <div className="mb-[1.5rem] me-[1.5rem] flex justify-end">
          <ArrowUpRight className="relative z-40 transition-transform group-hover:rotate-45" />
        </div>
      </div>

      {/* Gradient Overlay */}
      <div className="absolute inset-0 z-10 bg-image-overlay"></div>

      {/* Background Image */}
      <Image
        src={imgSrc}
        alt={`eSIM for ${name}`}
        fill
        sizes="auto"
        className="object-cover transition-all group-hover:opacity-75 group-hover:shadow-2xl"
        quality={70}
      />
    </div>
  );

  if (onClick) {
    return (
      <button type="button" onClick={onClick} className="w-full text-start">
        {content}
      </button>
    );
  }

  return (
    <div className="w-full">
      <Link
        href={
          pathName === "/data-voice-sms/regional/"
            ? `/${generateSlug(slug)}/`
            : `/regional/${slug}/`
        }
        className="w-full"
      >
        {content}
      </Link>
    </div>
  );
}

export default RegionImageCard;
